export default {
  applicant: {
    address1st: '千代田区神田紺屋町１３',
    address1stKana: 'チヨダクカンダコンヤチョウ１３',
    address2nd: 'サンビル４F',
    address2ndKana: 'サンビル４F',
    birthAtDay: '13',
    birthAtMonth: '04',
    birthAtYear: 1979,
    bloodType: 'A型',
    email: 'bsacjapan.developer@gmail.com',
    gender: '1',
    mobile: '090-222-2222',
    nameEn: 'TARO UMINO',
    nameKana: 'ウミノ　タロウ',
    nameJa: '海野　太郎',
    postCode: '1010035',
    prefecture: '東京都',
    tel: '03-111-1111',
    visitAtDay: (new Date().getDay() + 5).toString().padStart(2, '0'),
    visitAtMonth: (new Date().getMonth() + 1).toString().padStart(2, '0'),
    visitAtYear: new Date().getFullYear().toString(),
  },
  course: {
    id: 3,
    rankId: 223,
    name: 'オーシャンダイバー',
    price: null,
    priceWithTax: null,
  },
  diveCenter: {
    id: 9997,
    name: 'BSAC japan',
    email: 'bsacjapan.developer@gmail.com',
    others: '',
    othersEmail: '',
  },
  emergency: {
    address1st: '千代田区神田紺屋町１３（２）',
    address1stKana: 'チヨダクカンダコンヤチョウ１３（２）',
    address2nd: 'サンビル４F（２）',
    address2ndKana: 'サンビル４F（２）',
    email: 'bsacjapan.developer@gmail.com',
    familyRelationship: '父',
    mobile: '080-111-1111',
    name: '海野　次郎',
    nameKana: 'ウミノ　ジロウ',
    postCode: '1010034',
    prefecture: '東京都',
    tel: '03-222-2222',
  },
  rental: {
    height: '170.5',
    opticLeft: '1.22',
    opticRight: '1.01',
    shoeSize: '26.0',
    weight: '62.5',
  },
  requestBodyForRegister: null,
  payBy: null,
  registerResponse: {
    message: null,
    status: null,
    payBy: null,
    redirectUrl: null,
  },
  inputSummary: null,
};
